import dayjs from 'dayjs'
import { format as FNS_format } from 'date-fns'
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import duration from 'dayjs/plugin/duration'
import timezone from "dayjs/plugin/timezone.js";
import isBetween from 'dayjs/plugin/isBetween';


dayjs.extend(duration)
dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)
dayjs.extend(utc)
dayjs.extend(timezone);
dayjs.extend(isBetween);

export const referenceStartTime = () => dayjs().startOf('day')
export const referenceEndTime = () => dayjs().add(1, 'days').startOf('day')
export const referenceEndOfDay = () => dayjs().endOf('day')

export const isBetweenByDate = (today, start, end) => dayjs(today).isBetween(start, end, 'day', '[]')

export const dayjsDatetimeTranslate = (time) => {
    if (isNaN(time)) return `UNKNOWN`
    return dayjs(Number(time)).format("YYYY/MM/DD HH:mm:ss");
} 


export const parseTimeChart = (times) => dayjs(times).format('HH:mm');


export const today = dayjs();
export const todayStart = today.startOf("day").subtract(30, "day"); // Start of the day
export const todayEnd = today.endOf("day");

export const getCurrentDateFormat = () => dayjs().format("YYYYMMDD");
export const getCurrentDateTimeFormat = () => dayjs().format("YYYYMMDD_HHmmss");
export const getCurrentMonthAndYear = () => dayjs().format('YYYY-MM')

export const sanityCheckNumber = (number) => {
    return !isNaN(number) && number !== null && !isNaN(Number(number));
}

export const durationFormat = (duration) => {

    if (isNaN(duration)) return `N/A`

    const dayjsDuration = dayjs.duration(duration);

    const days = parseInt(dayjsDuration.asDays(), 10);
    const hrs = dayjsDuration.hours();
    const mins = dayjsDuration.minutes();
    const secs = dayjsDuration.seconds();

    return (
        days ?
            `${days} days ${hrs} hrs ${mins} mins` :
            hrs ?
                `${hrs} hrs ${mins} mins` :
                mins ?
                    `${mins} mins ${secs} secs` :
                    `${secs} secs`
    )
}

export const durationDiffFormat = (duration) => {
    if (isNaN(duration)) return `N/A`

    const dayjsDuration = dayjs.duration(duration);

    const years = parseInt(dayjsDuration.asYears(), 10);
    const months = parseInt(dayjsDuration.asMonths(), 10);
    const days = parseInt(dayjsDuration.asDays(), 10);
    const hrs = dayjsDuration.hours();
    const mins = dayjsDuration.minutes();
    const secs = dayjsDuration.seconds();

    return (
        years ?
            `${years} years` :
            months ?
                `${months} months`:
                days ?
                    `${days} days` :
                    hrs ?
                        `${hrs} hrs` :
                        mins ?
                            `${mins} mins` :
                            `${secs} secs`
    )
}

export const parseDurationInUnit = (duration) => {

    const dayjsDuration = dayjs.duration(duration);

    const year = dayjsDuration.asYears();
    const month = dayjsDuration.asDays()/30;
    const week = dayjsDuration.asWeeks();
    const day = dayjsDuration.asDays();

    return ({
        year,
        month,
        week,
        day
    })
}

export const parseSeconds = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
};

export const parseTime = time => {
    if (!time) return '-'
    return dayjs(Number(time)).format("YYYY/MM/DD HH:mm:ss");
}

export const parseTimeFNS = time => {
    if (!time) return '-'
    return FNS_format(time, "yyyy-MM-dd HH:mm:ss");
}

export const parseHours = millisec => {
    if (isNaN(millisec) && !millisec) return 0
    return millisec/(60*60*1000);
}

export const parseDate = (millisec) => {
    if (millisec === null || isNaN(Number(millisec))) return '-';

    return dayjs(millisec).format('YYYY/MM/DD');
}

export const getDayFullFormat = (epoch) => dayjs(epoch).format("dddd") 

export const parseExportTime = (time) =>
  ((time && dayjs(Number(time))) || dayjs()).format("YYYYMMDDHHmmss");

export const parseExcelDateToEpoch = (date) => {

    const excelStart = new Date(Date.UTC(1899, 11, 30)); // 30 Dec 1899, karena Excel bug-leap year
    return excelStart.getTime() + date * 24 * 60 * 60 * 1000;

    // const dateString = date
    // const [ day, month, year ] = dateString.split("/")

    // const dateObj = new Date(year, month - 1, day)
    // return dateObj.getTime();
}

export const parseDuration = (millisec) => {
    if (!sanityCheckNumber(millisec)) { return "-" }

    let seconds = (millisec / 1000).toFixed(0);
    let minutes = Math.floor(seconds / 60);
    let hours = 0;

    if (minutes > 59) {
        hours = Math.floor(minutes / 60);
        minutes = minutes - hours * 60;
    }

    seconds = Math.floor(seconds % 60);

    if (Number.isNaN(millisec)) {
        return " Not Available "
    }
    else if (hours > 0) {
        return `${hours} ${hours > 1 ? "hrs" : "hr"} ${minutes} ${minutes > 1 ? "mins" : "min"}`.trim()
    }
    else return `${millisec < 0 ? "-" : ""}${hours} hr ${minutes} min ${seconds > 0 && `${seconds} sec`|| ''}`.trim();

}

export const parseDurationHRS = (hrs) => {
    if (!sanityCheckNumber(hrs)) { return "-" }

    const millisec = hrs * 60 * 60 * 1000

    let seconds = (millisec / 1000).toFixed(0);
    let minutes = Math.floor(seconds / 60);
    let hours = 0;

    if (minutes > 59) {
        hours = Math.floor(minutes / 60);
        minutes = minutes - hours * 60;
    }

    seconds = Math.floor(seconds % 60);

    if (Number.isNaN(millisec)) {
        return " Not Available "
    }
    else if (hours > 0) {
        return `${hours} ${hours > 1 ? "hrs" : "hr"} ${minutes} ${minutes > 1 ? "mins" : "min"}`.trim()
    }
    else return `${minutes} ${minutes > 1 ? "mins" : "min"} ${seconds} ${seconds > 1 ? "secs" : "sec"}`.trim()
}

export const timeDiff = (startTime, endTime) => {
    const duration = parseDuration(dayjs(Number(endTime)).utc().diff(dayjs(startTime).utc()));

    return duration;
}

export const dayDiff = (startTime, endTime) => {
    const start = dayjs(startTime).startOf('day');
    const end = dayjs(endTime).startOf('day');

    return end.diff(start, 'day') + 1;
}

export const dayDiffABS = (startTime, endTime) => {
    return Math.abs(dayjs.duration(startTime.diff(endTime)).asDays())
}

export const dayJS = (time) => dayjs(time)
export const dayJSLocalize = (timeDayJS) => dayjs(timeDayJS.utc().valueOf())
// export const dayJSMilliSecond = (time) => dayjs(time).utc().valueOf();
export const dayJSMilliSecond = (time) => dayjs(time).valueOf();

export const isDayJS = (time) => dayjs.isDayjs(time)

export const getCurTimeDayJS = () => dayjs()
export const getCurTime = () => dayjs().utc().valueOf()
export const getCurtStartOfDate = () => dayjs().startOf('day').utc().valueOf()

export const lastNDay = (n = 1) => dayjs().subtract(n, "days").utc().valueOf();
export const nextNDay = (n = 1) => dayjs().add(n, "days").utc().valueOf();

// export const parseTimestamp = (time) => dayjs(time).utc().valueOf() ? dayjs(time).utc().valueOf() : dayjs(time).valueOf()
export const parseTimestamp = (time) => dayjs(time).valueOf()

export const parseStartOfDate = (time) => dayjs(time).startOf('day').utc().valueOf()

// export const getUTCToMalay = (str) => dayjs.utc(str).tz("Asia/Kuala_Lumpur").format("YYYY-MM-DD HH:mm:ss")
// export const getUTCToMalay = () => {}
export const getUTCToMalay = (str) => dayjs.utc(str).add(8, 'hour').format("YYYY-MM-DD HH:mm:ss")